import { createRoot } from 'react-dom/client'
import '#src/index.css'
import { Root } from '#src/Root.tsx'

const container = document.getElementById('root') as HTMLDivElement
const root = createRoot(container)

root.render(<Root />)
